<div class="dialog_main">
  <button class="dialog_close" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'SignUp' | translate }}</h2>
      <p>{{'LoginforExceptionalExperiences' | translate}}</p>
    </div>
    <mat-tab-group class="site_tabs" (selectedTabChange)="onTabChange($event)">
      <mat-tab [label]="'ContinueWithEmail' | translate">
        <form [formGroup]="signUpFormGroup">
          <div class="form_feilds">
            <div class="form_group">
              <mat-form-field appearance="fill">
                <input
                  matInput
                  [placeholder]="'EmailAddress' | translate"
                  class="form_control"
                  formControlName="email" />
                @if (submitted) {
                  @for (err of emailErrors; track $index) {
                    @if (signUpFormGroup.controls['email'].hasError(err.key)) {
                      <mat-error>{{ err.message | translate }} </mat-error>
                    }
                  }
                }
              </mat-form-field>
            </div>
          </div>
          <div class="form_btn">
            <button class="btn btn_primary" (click)="openVerificationModal()">
              {{ 'Continue' | translate }}
            </button>
          </div>
        </form>
      </mat-tab>
      <mat-tab [label]="'ContinueWithPhoneNumber' | translate">
        <form [formGroup]="signUpFormGroup">
          <div class="form_feilds">
            <div class="form_group">
              <ngx-mat-intl-tel-input
                [preferredCountries]="['ae', 'gb']"
                [enablePlaceholder]="true"
                [enableSearch]="true"
                name="phone"
                describedBy="phoneInput"
                formControlName="phoneNo"
                class="phone_selector"
                maxlength="15"
                #phone
                (countryChanged)="
                  countryChangedEvent($event)
                "></ngx-mat-intl-tel-input>
              <div>
                @if (submitted) {
                  @if (
                    (signUpFormGroup.get('phoneNo')?.value === '' ||
                      signUpFormGroup.get('phoneNo')?.value === null) &&
                    signUpFormGroup.get('phoneNo')?.hasError('required')
                  ) {
                    <mat-error
                      >{{ 'PhoneNumber' | translate }}
                      {{ 'isRequired' | translate }}</mat-error
                    >
                  }
                  @if (
                    signUpFormGroup.get('phoneNo')?.value === undefined ||
                    signUpFormGroup
                      .get('phoneNo')
                      ?.hasError('validatePhoneNumber')
                  ) {
                    <mat-error
                      >{{ 'PleaseEnterValid' | translate }}
                      {{ 'PhoneNumber' | translate }}
                    </mat-error>
                  }
                }
              </div>
            </div>
          </div>
          <div class="form_btn">
            <button class="btn btn_primary" (click)="openVerificationModal()">
              {{ 'Continue' | translate }}
            </button>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
